import { zodResolver } from '@hookform/resolvers/zod'
import { z } from 'zod'

import { type PathKey } from '~/apps/ninesegsAnalyzer/routes/paths'
import { dataDisplayTypes, surveyFilterGroupsSchema } from '~/utils'

export const pathKey = 'strategyMemoEdit' satisfies PathKey

const strategyTypeSchema = z.enum(['new', 'existing', 'free'])
export type StrategyType = z.infer<typeof strategyTypeSchema>

const schema = z.object({
  surveyId: z.string().nullable(),
  brandGroupId: z.number().nullable(),
  brandId: z.number().nullable(),
  surveyFilter: z.object({
    count: z.number().optional(),
    filterGroups: surveyFilterGroupsSchema,
  }),
  dataDisplayType: z.enum(dataDisplayTypes),
  title: z.string(),
  goal: z.string(),
  strategies: z.array(
    z.object({
      id: z.string(),
      strategyType: strategyTypeSchema,
      showArrow: z.boolean(),
      segmentRoutes: z.array(
        z.object({
          fromSegmentNumber: z.number(),
          toSegmentNumber: z.number(),
        }),
      ),
      who: z.string(),
      what: z.string(),
      how: z.string(),
    }),
  ),
})
export type InputValues = z.infer<typeof schema>
export const resolver = zodResolver(schema)
